import { Component, inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthStore } from '@root/app/store/auth.store';
import { AuthService } from '../../../core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { AuthorizationContainerComponent } from '../authorization-container/authorization-container.component';
import { TextFieldComponent } from '@custom-components/general/form/text-field/text-field.component';
import { FilledButtonComponent } from '@custom-components/general/button/filled-button/filled-button.component';
import { AlertBannerComponent } from '@custom-components/feedback/alert-banner/alert-banner.component';

@Component({
  selector: 'xemex-reset-password-page',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    AuthorizationContainerComponent,
    TextFieldComponent,
    FilledButtonComponent,
    AlertBannerComponent,
  ],
  standalone: true,
  providers: [AuthService],
  templateUrl: './reset-password-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password-page.component.scss',
})
export class ResetPasswordPageComponent implements OnInit {
  readonly store = inject(AuthStore);

  email = new FormControl('', [Validators.required, Validators.email]);

  ngOnInit(): void {
    this.store.clearAuthFeedback();
  }

  onResetPassword() {
    if (this.email.invalid || !this.email.value) {
      this.email.markAsTouched();
      return;
    }
    this.store.sendLinkResetPasswordToEmailMethod(this.email.value);
  }
}
